import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { announce } from '@react-aria/live-announcer';
import { useId } from '@react-aria/utils';
import { useEffect } from 'react';
import { Circle1, Circle2, Wrapper } from './styles';
const LOADER_LOG_AFTER_MS = 3000;
const Loader = ({ color = 'white', className, announcement = 'Loading', title = 'Loading spinner', description = 'Two circles spinning around', context, logDelay = LOADER_LOG_AFTER_MS, logger, }) => {
    const titleId = useId();
    const descriptionId = useId();
    useEffect(() => {
        if (!logger)
            return;
        const timeoutId = setTimeout(() => {
            logger('Loading is taking a while', Object.assign(Object.assign({}, context), { timeOnScreen: logDelay }));
        }, logDelay);
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [context, logDelay, logger]);
    useEffect(() => {
        announce(announcement, 'polite');
    }, [announcement]);
    return (_jsxs(Wrapper, { viewBox: "0 0 100 50", color: color, "data-testid": "loader", role: "status", "aria-labelledby": titleId, "aria-describedby": descriptionId, className: className, children: [_jsx("title", { id: titleId, children: title }), _jsx("desc", { id: descriptionId, children: description }), _jsx(Circle1, { cx: "25", cy: "25", r: "10" }), _jsx(Circle2, { cx: "75", cy: "25", r: "10" })] }));
};
export default Loader;
//# sourceMappingURL=index.js.map